import { render, staticRenderFns } from "./StatementModal.vue?vue&type=template&id=1d631a38&scoped=true"
import script from "./StatementModal.vue?vue&type=script&lang=js"
export * from "./StatementModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d631a38",
  null
  
)

export default component.exports